import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-after-logout',
  templateUrl: './after-logout.component.html',
  styleUrls: ['./after-logout.component.scss']
})
export class AfterLogoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
